import React from "react";
import { Link } from "react-router-dom";
import { fmtNum } from "@/lib/format";
import { useMarket } from "@/lib/MarketContext";

export default function MarketHeader() {
  const market = useMarket();
  const snap = market?.snap;
  const brokerConfig = market?.brokerConfig;

  const chip = (idx) => {
    const d = snap?.[idx];
    if (!d) {
      return (
        <div key={idx} className="flex items-baseline gap-1.5 sm:gap-2 min-w-0" data-testid={`ticker-${idx.toLowerCase()}`}>
          <span className="text-[10px] sm:text-xs uppercase tracking-widest text-slate-500">{idx}</span>
          <span className="font-mono text-xs sm:text-sm text-slate-500">—</span>
        </div>
      );
    }
    if (d.spot == null) {
      return (
        <div key={idx} className="flex items-baseline gap-1.5 sm:gap-2 min-w-0" data-testid={`ticker-${idx.toLowerCase()}`}>
          <span className="text-[10px] sm:text-xs uppercase tracking-widest text-slate-500">{idx}</span>
          <span className="font-mono text-xs sm:text-sm text-slate-500">—</span>
        </div>
      );
    }
    const up = (d.change ?? 0) >= 0;
    return (
      <div key={idx} className="flex items-baseline gap-1.5 sm:gap-2 min-w-0" data-testid={`ticker-${idx.toLowerCase()}`}>
        <span className="text-[10px] sm:text-xs uppercase tracking-widest text-slate-500">{idx}</span>
        <span className="font-mono text-xs sm:text-sm text-slate-100">{fmtNum(d.spot)}</span>
        <span className={`font-mono text-[10px] sm:text-xs whitespace-nowrap ${up ? "text-emerald-400" : "text-rose-400"}`}>
          {up ? "+" : ""}{fmtNum(d.change)} ({up ? "+" : ""}{fmtNum(d.change_pct, 2)}%)
        </span>
      </div>
    );
  };

  const dataSourceLabel = () => {
    if (snap?.live && snap?.data_source) {
      return (
        <span
          className="px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-widest font-semibold bg-blue-500/15 text-blue-300 whitespace-nowrap"
          data-testid="data-source"
        >
          Live · {snap.data_source}
        </span>
      );
    }
    if (brokerConfig) {
      return (
        <Link
          to="/settings"
          className="px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-widest font-semibold bg-emerald-500/15 text-emerald-400 hover:bg-emerald-500/25 whitespace-nowrap"
          data-testid="data-source"
          title={snap?.error || "Market data unavailable outside trading hours"}
        >
          {brokerConfig.broker} · connected
        </Link>
      );
    }
    return (
      <Link
        to="/settings"
        className="px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-widest font-semibold bg-amber-500/15 text-amber-400 hover:bg-amber-500/25 whitespace-nowrap"
        data-testid="data-source"
      >
        Connect broker
      </Link>
    );
  };

  return (
    <div className="border-b border-white/10 bg-[#0d0d0d] px-3 sm:px-6 py-2.5 sm:py-3">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        {chip("NIFTY")}
        {chip("SENSEX")}
        <div className="flex items-center gap-2 flex-wrap ml-auto">
          {dataSourceLabel()}
          <span
            className={`px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-widest font-semibold whitespace-nowrap ${
              snap?.market_status === "OPEN"
                ? "bg-emerald-500/15 text-emerald-400"
                : "bg-slate-500/15 text-slate-400"
            }`}
            data-testid="market-status"
          >
            Market {snap?.market_status || "..."}
          </span>
          <span className="font-mono text-[10px] sm:text-xs text-slate-400 whitespace-nowrap" data-testid="ist-clock">
            IST {snap?.ist_time || "—"}
          </span>
        </div>
      </div>
    </div>
  );
}
